<script setup>
import card_header from '@/components/card_header.vue';
import progress_item from './progress_item.vue';
import history_chart from './history_chart.vue';
import { get_terms } from '@/services/term'
import { onMounted, ref } from 'vue';
import { get_assessment_history } from '@/services/assessment';
import { swalError } from '@/helper';
import { get_assessment } from '@/services/assessment';

const props = defineProps({
  trait: {
    type: Object,
    required: true
  },
  child: {
    type: Object,
    required: true
  },
  isEmptyData: {
    type: Boolean,
    required: true
  }
})

const filterOption = ref([])
onMounted(async()=>{
  if (props.isEmptyData){
    isLoading.value = false
    return
  }
  if (props.child?.attributes){
    await parse_assessment_history()
    isLoading.value = false
  }
  let age_groups_response = await get_terms('age_group')
  filterOption.value = age_groups_response.result.data.data.map(item => {
    return {
      ...item,
      isActive: false
    }
  })
})

const history = ref({})
async function parse_assessment_history(){
  let response = await get_assessment_history(props.trait.id, props.child.id)
  if (response.error){
    swalError(response.result, true)
    return
  }

  // grouping the assessment group based on the assessment id
  const groupAssProgress = response.result.data.reduce((acc, obj) => {
    const key = obj.attributes.assessment_id;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
  // console.log("🚀 ~ groupAssProgress ~ groupAssProgress:", groupAssProgress)
  
  // get assessment and term
  for (const key in groupAssProgress) {
    if (groupAssProgress.hasOwnProperty(key)) {
      // console.log(`Processing Assessment ID: ${key}`);
      let response = await get_assessment(key)
      // console.log("🚀 ~ //processGroupedObjects ~ response:", response)
      groupAssProgress[key] = {
        ...response.result,
        progress: [...groupAssProgress[key]]
      }
    }
  }

  // group the by term
  const groupedObjects = Object.entries(groupAssProgress).reduce((acc, [key, value]) => {
    const termId = value.term.id;
    // const assessments = []
    if (!acc[termId]) { // term x da
      acc[termId] = {assessments: []};
    }
    // acc[termId].push({ key: key, ...value });
    // assessments.push({...value})
    acc[termId].term = value.term
    acc[termId].assessments.push({...value})
    //  = {term: value.term, assessments};
    return acc;
  }, {});
  // console.log("🚀 ~ groupedObjects ~ groupedObjects:", groupedObjects)
  // set active history
  currentHistory.value = Object.values(groupedObjects).map(group => group)[0].term.id;
  // console.log("🚀 ~ parse_assessment_history ~ currentHistory.value:", currentHistory.value)
  history.value = groupedObjects
}

const currentHistory = ref('')
const isLoading = ref(true)
function filterHistory(historyObj){
  currentHistory.value = historyObj.term.id
}
</script>

<template>
  <div class="col-12">
    <div class="card">
      <card_header 
        :title="'Report History'" 
        :has_border="true"
        :is_narrow="true"
      ></card_header>
      <loadingCard v-if="isLoading"/>
      <div class="card-body pt-3" v-else>
        <EmptyCard v-if="isEmptyData" 
          :needLink="false"
          text="Start your intervention now"
        />
        <template v-else>
          <!-- Age Group Filter -->
          <div class="d-flex mb-3 overflow-x-auto">
            <button v-for="historyObj in history" :key="historyObj.term.id" 
              class="me-4 btn btn-light-primary shadow-sm px-4 py-2 rounded-pill"
              @click="filterHistory(historyObj)"
              :class="{'active': historyObj.term.id == currentHistory}"
            >
              {{ historyObj.term.name }}
            </button>
          </div>
          <!-- Progress Item -->
          <template v-for="historyObj in history" 
            :key="historyObj.term.id"
          >
            <div v-if="currentHistory == historyObj.term.id" 
              class="row report-history-progress"
            >
              <div class="col-md-6">
                <template v-for="assessment in historyObj.assessments" :key="assessment.assessment.data.id" >
                  <template v-for="progress in assessment.progress" :key="progress.id">
                    <progress_item :item="progress" :child="child"/>
                  </template>
                </template>
              </div>
              <div class="col-md-6 my-auto">
                <history_chart :assessment_histories="historyObj.assessments"/>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>